import { Component, Vue,} from 'vue-property-decorator'
import ShippingCollectiveRegisterList from './ShippingCollectiveRegisterList/ShippingCollectiveRegisterList.vue'
import { LoginUser } from '@/types/Component';

@Component({
    components: {
        ShippingCollectiveRegisterList
    }
})
export default class AdditionalFunction extends Vue {
    navItem = "shipping-collective-register-list"

    mounted() {
        this.$watch('$store.getters.currentPageName', this.currentMenu, { immediate: true });
    }

    currentMenu(){
        const path = this.$route.path
        const pathList = path.split('/')
        this.navItem = pathList[2]
    }

    get hasProducerPlanOnly():LoginUser {
        return this.$store.getters.loginUser.hasProducerPlanOnly
    }

    created(){
        if(this.$store.getters.loginUser.hasProducerPlanOnly === true){
        alert("農薬ナビに参加していない為、利用できません");
        return;
        }
    }
}